import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=1eb97070&scoped=true&"
import script from "./UserCard.vue?vue&type=script&lang=js&"
export * from "./UserCard.vue?vue&type=script&lang=js&"
import style0 from "./UserCard.vue?vue&type=style&index=0&id=1eb97070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb97070",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/.jenkins/workspace/crm-ui/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eb97070')) {
      api.createRecord('1eb97070', component.options)
    } else {
      api.reload('1eb97070', component.options)
    }
    module.hot.accept("./UserCard.vue?vue&type=template&id=1eb97070&scoped=true&", function () {
      api.rerender('1eb97070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/profile/components/UserCard.vue"
export default component.exports